import styled from 'styled-components';
import { MediaQuery, Size } from '../../constant/breakpoint.ts';

export const Section = styled('div')({
    backgroundColor: "#EEEEEE",
    padding: "4%",

    [MediaQuery[Size.MD]]: {
        paddingTop: "4%",
        paddingBottom: "4%",
        paddingLeft: "0%",
        paddingRight: "0%",
    },

    [MediaQuery[Size.SM]]: {
        paddingTop: "20px",
        paddingBottom: "20px",
        paddingLeft: "20px",
        paddingRight: "20px",
    },
})

export const Title = styled('div')({
    fontSize: "50px",
    fontWeight: "425",

    [MediaQuery[Size.LG]]: {
        fontSize: "32px",
    },
    [MediaQuery[Size.MD]]: {
        paddingLeft: "4%",
        paddingRight: "4%",
        lineHeight: "40px",
    },
})

export const TitleSec = styled('span')({
    color: "#A39F9F"  
})

export const Name = styled('div')({
    color: "#CCA25E",
    fontSize: "32px",
    fontWeight: "600",
    marginTop: "36px",
    lineHeight: "32px",
    fontFamily: "Gotham",
    whiteSpace: "pre-line",
    height: "60px",
    [MediaQuery[Size.LG]]: {
        fontSize: "24px",
    },
    [MediaQuery[Size.MD]]: {
        fontSize: "32px",
    },
    [MediaQuery[Size.SM]]: {
        fontSize: "28px",
    },
})

export const Department = styled('div')({
    fontSize: "18px",
    fontWeight: "425",
    marginTop: "16px",
    height: "48px",
})

export const UserBoxContainer = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: '60px',
    rowGap: "40px",
    alignItems: "center",
    [MediaQuery[Size.MD]]: {
        marginTop: '40px',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    '@media (max-width: 440px)' : {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
})

export const UserBox = styled('div')({
    width: '360px',

    [MediaQuery[Size.XL]]: {
        width: "300px"
    },
    [MediaQuery[Size.LG]]: {
        width: "240px"
    },
    [MediaQuery[Size.MD]]: {
        width: "410px"
    },
    '@media (max-width: 440px)' : {
        width: "340px"
    },
    '@media (max-width: 360px)' : {
        width: "280px"
    },
    '@media (max-width: 300px)' : {
        width: "240px"
    },
})


export const ImageBox = styled('img')({
    width: '360px',
    height: 'auto',
    
    [MediaQuery[Size.XL]]: {
        width: '300px'
    },
    [MediaQuery[Size.LG]]: {
        width: '230px'
    },
    [MediaQuery[Size.MD]]: {
        width: 'auto'
    },

    '@media (max-width: 440px)' : {
        width: '340px'
    },
    '@media (max-width: 360px)' : {
        width: "280px"
    },
    '@media (max-width: 300px)' : {
        width: "240px"
    },
})

export const SendEmailButton = styled('div')({
    width: "50%",
    height: "100%",
    borderRadius: "45px",
    backgroundColor: "#CCA25E",
    display: "flex",
    alignItems: 'center',
    justifyContent: 'center',
    color: "white",
    marginTop: "12px",
    padding: "4px",
    cursor: "pointer",

    [MediaQuery[Size.XL]]: {
        width: "100%"
    },
    [MediaQuery[Size.MD]]: {
        width: "50%"
    },
    '@media (max-width: 440px)' : {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
    },
})


export const LinkedinButton = styled('div')({
    width: "50%",
    height: "auto",
    borderRadius: "45px",
    display: "flex",
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: "#D9D9D9",
    color: "black",
    padding: "4px",
    marginTop: "12px",
    marginLeft: "20px",
    [MediaQuery[Size.XL]]: {
        width: "100%"
    },
    [MediaQuery[Size.LG]]: {
        marginLeft: "0px",
    },
    [MediaQuery[Size.MD]]: {
        marginLeft: "20px",
        width: "50%"
    },
    '@media (max-width: 440px)' : {
        marginLeft: "0px",
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
    },
})

export const ButtonFlexbox = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    [MediaQuery[Size.XL]]: {
        flexDirection: 'column',
    },
    [MediaQuery[Size.MD]]: {
        flexDirection: 'row',
    },
    '@media (max-width: 440px)' : {
        flexDirection: 'column',
    },
})

export const BoxImage = styled('div')({
    position: 'relative'
})

export const WhiteCircle = styled('div')({

    position: "absolute",
    left: '280px',
    bottom: '-20px',

    height: '111px',
    width: '111px',
    backgroundColor: 'white',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 4,

    [MediaQuery[Size.XL]]: {
        left: '208px',
        bottom: '-20px',
    },

    [MediaQuery[Size.LG]]: {
        left: '174px',
        bottom: '-20px',
        height: '80px',
        width: '80px',
    },

    [MediaQuery[Size.MD]]: {
        left: '332px',
        bottom: '-20px',
    },

    [MediaQuery[Size.SM]]: {
        left: '330px',
        bottom: '-20px',
    },

    '@media (max-width: 440px)' : {
        left: '280px',
        height: '71px',
        width: '71px',
    },
    '@media (max-width: 360px)' : {
        left: '220px',
        height: '71px',
        width: '71px',
    },
    '@media (max-width: 310px)' : {
        left: '200px',
    },
    '@media (max-width: 300px)' : {
        left: '190px',
    },
    '@media (max-width: 290px)' : {
        left: '180px',
    },
    '@media (max-width: 280px)' : {
        left: '170px',
    },
    '@media (max-width: 270px)' : {
        left: '160px',
    },
    '@media (max-width: 260px)' : {
        left: '150px',
    },
    '@media (max-width: 250px)' : {
        left: '140px',
    },
    '@media (max-width: 240px)' : {
        left: '130px',
    },
    '@media (max-width: 230px)' : {
        left: '120px',
    },
    
    
})

export const YellowCircle = styled('div')({
    height: '77px',
    width: '77px',
    backgroundColor: '#CCA25E',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    [MediaQuery[Size.LG]]: {
        height: '56px',
        width: '56px',
    },
    '@media (max-width: 440px)' : {
        height: '50px',
        width: '50px',
    },
})

export const StarImg = styled('img')({
    [MediaQuery[Size.LG]]: {
        height: '32px',
        width: '32px',
    },
    '@media (max-width: 440px)' : {
        height: '34px',
        width: '34px',
    },
})